import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DiscoverLink from 'components/DiscoverLink';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.h5,
    },
  },
}));

function SectionTitle({
  title,
  link,
  linkLabel,
  clickHandler,
  variant,
  color,
}) {
  const classes = useStyles();
  return (
    <Grid item xs={12} container className={classes.root}>
      <Typography className={classes.title} color={color} variant={variant}>
        {title}
      </Typography>
      {link && (
        <Hidden smDown>
          <DiscoverLink
            link={link}
            label={linkLabel}
            clickHandler={clickHandler}
          />
        </Hidden>
      )}
    </Grid>
  );
}

SectionTitle.propTypes = {
  title: PropTypes.string,
  link: PropTypes.string,
  linkLabel: PropTypes.string,
  clickHandler: PropTypes.func,
  variant: PropTypes.string,
  color: PropTypes.string,
};

SectionTitle.defaultProps = {
  clickHandler: () => {},
  linkLabel: 'View All',
  variant: 'h4',
  color: 'textPrimary',
};

export default SectionTitle;
